import type {IconDefinition} from '@fortawesome/fontawesome-svg-core';

// Create a FontAwesome-style IconDefinition for the custom SVG
export const denyWithAiIcon: IconDefinition = {
  iconName: `deny-with-ai` as any,
  prefix: `custom` as any,
  icon: [
    21, // width
    21, // height
    [], // ligatures
    `e001`, // unicode
    [
      // Primary path (main icon shape)
      `M11.0002 3.00195C13.1205 3.00424 15.1532 3.84753 16.6526 5.34668C18.152 6.84612 18.996 8.87947 18.9983 11C18.9983 12.5817 18.5293 14.1282 17.6506 15.4434C16.7718 16.7586 15.5222 17.7843 14.0608 18.3896C12.5994 18.9949 10.9911 19.1533 9.43967 18.8447C7.88824 18.5361 6.46347 17.7738 5.34494 16.6553C4.22643 15.5368 3.46411 14.112 3.15549 12.5605C2.96477 11.6018 2.95224 10.6211 3.11349 9.66699L4.24533 10.5996C4.23754 10.7326 4.2325 10.8661 4.23263 11C4.23337 12.2855 4.60024 13.5443 5.29025 14.6289C5.98025 15.7134 6.96514 16.5787 8.12912 17.124C9.29312 17.6694 10.5886 17.8719 11.8635 17.708C13.1383 17.544 14.3402 17.0203 15.3283 16.1982L7.93283 8.80273C8.20836 8.50122 8.51355 8.22326 8.84787 7.97656L16.1985 15.3281C17.2138 14.1147 17.7694 12.5822 17.7678 11C17.7671 9.71452 17.4002 8.45569 16.7102 7.37109C16.0202 6.28655 15.0353 5.42137 13.8713 4.87598C13.1733 4.54892 12.4279 4.3459 11.6682 4.27051L10.0754 3.05566C10.3813 3.02007 10.6901 3.00195 11.0002 3.00195Z`,
      // Secondary path (checkmark for approval)
      `M5.69824 0.179688L6.97103 3.9069L10.6982 5.17969L6.97103 6.45248L5.69824 10.1797L4.42545 6.45248L0.698242 5.17969L4.42545 3.9069L5.69824 0.179688Z`,
    ],
  ],
};

export const denyWithAiIconProps = {
  className: `size-5`,
  style: {
    '--fa-primary-color': `#0045E2`,
    '--fa-primary-opacity': `1`,
    '--fa-secondary-opacity': `1`,
  } as React.CSSProperties,
};
